// extracted by mini-css-extract-plugin
module.exports = {"root":"n60-footer_root__K_FWL","trustpilotWrapper":"n60-footer_trustpilotWrapper__eF__t","grid":"n60-footer_grid__nqPdF","divider":"n60-footer_divider__aagbh"};